var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Title',{attrs:{"title":"慈善项目"}}),_c('div',{staticClass:"layout-view withoutTitle pb0"},[_c('div',{staticClass:"components-layout pd0"},[_c('div',{staticClass:"cishanxiangmu"},[_c('EmptyData')],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }